module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 2.26129","quantity":0.02261},{"color":"#9dc4b5","label":" 2.26129- 3.32995","quantity":0.0333},{"color":"#e6efc3","label":" 3.32995- 4.29522","quantity":0.04295},{"color":"#ffe89e","label":" 4.29522- 5.61797","quantity":0.05618},{"color":"#f5af7f","label":" 5.61797- 7.44096","quantity":0.07441},{"color":"#ed6d32","label":" 7.44096- 19.26572","quantity":0.19266}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_90_return_10.json
// module id = 3w1R
// module chunks = 171